import {Button, Col, Form, Modal, Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React, {useEffect, useState} from "react";
import Dropdown from "react-dropdown";
import {faSave} from "@fortawesome/free-solid-svg-icons";

function IndMaterialModal(props) {

    const onTextAreaChange = (text) => {
    const lines = parseText(text);
    const evaluatedLines = lines.map((line) => evalText(line));
    const total = evaluatedLines.reduce((sum, value) => sum + value, 0);
    return total.toString().replace(/\./g, ',');
};

    useEffect(async ()=>{
        setNewEihneit("")
        setNewAufmas("")
        setNewDescription("")
        setNewMenge("0")
    },[props.indshow])
const parseText = (e) => {
    const text = e
    const lines = text.split('\n');
    return lines.filter((line) => line.trim() !== ''); // Filter out empty lines
};

const evalText = (text) => {
    try {
        const problem = text.split('=')[1];
        if (!problem) return 0;
        return eval(problem.toString().replace(/,/g, '.'))
    } catch (e) {
        return 0;
    }
};

    let newID = "000"
    const [newDescription, setNewDescription] = useState("")
    const [newEihneit, setNewEihneit] = useState("")
    const [newMenge, setNewMenge] = useState("0")
    const [newAufmas, setNewAufmas] = useState("0")


    function handleNewMaterialAdd(newDescription, newEihneit, newMenge,newAufmas) {

        /*if (props.individualMaterialDataInfo.find(item => item.id === newID) === undefined) {

            props.setIsChange(false)

            newID = 'individualMaterialID' + (new Date()).getTime();

            props.setIndividualMaterialData([...props.individualMaterialDataInfo, {
                "id": newID, "position": "-", "description": newDescription, "menge": newMenge, "unit": newEihneit,
                "source":"-", "aufmas":""
            }])

            props.individualMaterialDataInfo.push({
                "id": newID, "position": "-", "description": newDescription, "menge": newMenge, "unit": newEihneit,
                "source":"-", "aufmas":""
            })

        } else {
            alert("Es ist schon da!")
        }*/
        if (props.taetigkeitsberichtData.material.find(item => item.id === newID) === undefined) {

            props.setIsChange(false)

            newID = 'individualMaterialID' + (new Date()).getTime();

            let duplicatetatig = props.taetigkeitsberichtData
            duplicatetatig.material.push({
                "id": newID, "position": "-", "description": newDescription, "menge": newMenge, "unit": newEihneit,
                "source":"Individual", "aufmas":newAufmas
            })
            props.setTaetigkeitsberichtData(duplicatetatig)

        } else {
            alert("Es ist schon da!")
        }

        return null;
    }

    let options = ["m", "m²", "m³", "l", "kg", "stk"]
    return (<Modal show={props.indshow} onHide={props.handleIndClose}
                   aria-labelledby="contained-modal-title-vcenter"
                   centered>
        <Modal.Header closeButton>
            <Modal.Title>Neu Individuell Material</Modal.Title>
        </Modal.Header>
        <Modal.Body className="handwai-dark">
            <Form.Group as={Row}>
                <Form.Label column sm="4"
                            className="handwai-text-label-normal"
                >
                    {'Beschreibung:'}
                </Form.Label>
                <Col sm="4">
                    <textarea
                        className="handwai-dark handwai-text-label-normal add-bottom-21-padding"
                        style={{width: "300px", height: "200px"}}
                        defaultValue={""}
                        onChange={(e) => {
                            setNewDescription(e.target.value)
                        }}
                    />
                </Col>
            </Form.Group>
            <br/>
            <Form.Group as={Row}>
                <Form.Label column sm="4"
                            className="handwai-text-label-normal"
                >
                    {'Einheit:'}
                </Form.Label>
                <Col sm="4">
                    <Dropdown options={options} value={""} placeholder="Wählen"
                              onChange={(e) => setNewEihneit(e.value)}/>
                </Col>
            </Form.Group>
            <br/>

            <Form.Group as={Row}>
                <Form.Label column sm="4"
                            className="handwai-text-label-normal"
                >
                    {'Aufmaß:'}
                </Form.Label>
                {/*<Col sm="4">
                    <input type="text" className="table-input"
                           style={{width: "300px", height: "50px"}}
                           defaultValue={""}
                           onChange={(e) => {
                               setNewAufmaß(e.target.value)
                           }}
                    />
                </Col>*/}
                <Col sm={4}>
                    <textarea
                        defaultValue={""}
                        value={newAufmas}
                    style={{ backgroundColor: '#1b1b1b', color: '#fff' }}
                    onChange={(e) => {
                        const menge = onTextAreaChange(e.target.value)
                        setNewMenge(menge)
                        setNewAufmas(e.target.value)
                    }}
                    />
                </Col>
            </Form.Group>
            <Form.Group as={Row}>
                <Form.Label column sm="4"
                            className="handwai-text-label-normal"
                >
                    {'Menge:'}
                </Form.Label>
                <Col sm="4">
                    <input type="text" className="table-input"
                           style={{width: "300px", height: "50px"}}
                           defaultValue={""}
                           value={newMenge}
                        //    disabled={true}
                           onChange={(e) => {
                               setNewMenge(e.target.value)
                               setNewAufmas('')
                           }}
                    />
                </Col>
            </Form.Group>

        </Modal.Body>
        <Modal.Footer>
            <Button size='lg' block className='handwai-btn-green'
                    onClick={() => {
                        props.handleIndClose()
                        handleNewMaterialAdd(newDescription, newEihneit, newMenge,newAufmas)
                    }}
            > <FontAwesomeIcon
                icon={faSave}/> &emsp;
                Speichern
            </Button>
        </Modal.Footer>
    </Modal>);
}

export default IndMaterialModal